import React, { useState, useRef, useEffect } from 'react';
import Tabs from '../../../../Components/Tabs';
import editIcon from '../../../../Assets/Icons/edit.png';
import deleteIcon from '../../../../Assets/Icons/delete.png';
import forwordIcon from '../../../../Assets/Icons/forward.png'
import AddTaskCategoryModal from '../../../../Components/Modals/AddTaskCategoryModal';
import Input from '../../../../Components/Input';
import filterIcon from '../../../../Assets/Icons/filter.png'
import leftBtuIcon from '../../../../Assets/Icons/back.png'
import AddUserModal from '../../../../Components/AddUserModal';
import leftArrowIcon from '../../../../Assets/Icons/chevron-down.png';
import { useNavigate } from 'react-router-dom';
import InvoiceReceiptController from '../../../Controllers/AdminScreens/Invoices/InvoiceReceiptController';
import GenerateReceiptModal from '../../../../Components/Modals/GenerateReceiptModal';
import TextInput from '../../../../Components/TextInput';
import DateInput from '../../../../Components/DateInput';
import search from '../../../../Assets/Icons/search.png';
import Dropdown from '../../../../Components/Dropdown';
import printerIcon from '../../../../Assets/Icons/Printer.png';
import Loader from '../../../../Components/Loader';
import { convertGMTToLocal } from '../../../../Utils/Validation';
import printIcon from '../../../../Assets/Icons/Printer.png';

const InvoiceReceiptScreen = ({ receiptList, loading, error, onRefresh }) => {

  const {
    handlePageChange,
    currentTasks,
    totalPages,
    currentPage, visiblePages,
    filterData,
    setFilterData,
    handleFilterChange,
    applyFilters, cancelFilters, resetFilters, toggleFilters,
    filterError, showFilters, filterListLoading, filterListError,
    searchUser, searchLoading, searchError, clientList,
    serviceOptions, servicesLoading, servicesError,
    userOptions, userLoading, userError,
    handleSearchInputText, handleSearchClient, handleSelectClient,
    printReceiptDocument, printReceiptLoading, printReceiptError
  } = InvoiceReceiptController(receiptList, onRefresh);

  const [userPermissions, setUserPermissions] = useState(null);
  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    setUserPermissions(storedUserInfo?.user_permissions || {});
  },[])

  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleGenerateReceipt = () => {
    setIsModalOpen(true); // Open the modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const handleAddReceipt = (data) => {
    //console.log('Receipt Data:', data); // Handle receipt addition logic
    setIsModalOpen(false); // Close the modal after adding
  };

  const handleEdit = (receipt) => {
    if (userPermissions?.invoices?.per_name_sub_json?.receipt_edit === 1) {
      console.log('receipt',receipt);
      const prepReceiptData = {
        searchInvoice: receipt?.invoice_id_gen || '',
        advancePayment: receipt?.advance_pay_flag || 0,
        clientId: receipt?.client_id || 0
      }
      navigate('/generate-edit-receipt', { state: { receiptData: receipt } });
    }
  }


  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <>
      <div className='basic-info-container'>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h3 style={styles.categoryHeader}>Receipts</h3>
          <div>
            {userPermissions?.invoices?.per_name_sub_json?.receipt_gen === 1 &&
            <button className="add-client-button" style={{ paddingLeft: 30, paddingRight: 30 }} onClick={handleGenerateReceipt}>
              Generate Receipt
            </button>
            }
          </div>
        </div>
        <div style={styles.container}>
          <div style={styles.filtersHeader}>
            <button style={styles.filterButton} onClick={toggleFilters}> <img src={filterIcon} style={styles.filterIcon} /> Filters</button>
            <div >
              <img src={leftBtuIcon} style={{ marginRight: '5px', cursor: 'pointer', width: '28px', height: '28px' }} />
              <img src={leftBtuIcon} style={{ transform: 'rotate(180deg)', transition: 'transform 0.3s ease', cursor: 'pointer', width: '28px', height: '28px' }} />
            </div>
          </div>
        </div>
        {/* Filters using Flexbox */}
        {showFilters && (
          <div className={`tasksScreen-filters-container ${showFilters ? 'tasksScreen-open-filters' : ''}`}>
            <div className="tasksScreen-filters">
              <div className="filter-field" >
                <label>Client Name</label>
                <TextInput
                  type="text"
                  placeholder="Client Name"
                  value={searchUser}
                  onChange={(e) => handleSearchInputText(e.target.value)}
                  onRightClick={handleSearchClient}
                  right={
                    searchLoading ? (
                      <Loader loading={searchLoading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                    ) : (
                      <img src={search} alt="Search" style={{ cursor: 'pointer',height: '20px', width: '20px' }} />
                    )
                  }
                  style={{ padding: '20px 10px' }}
                  errorMessage={searchError}
                />
                {clientList?.length > 0 && (
                  <ul style={styles.dropdownList}>
                    {clientList?.map((client, index) => (
                      <li
                        key={client?.client_id}
                        onClick={() => handleSelectClient(client)}
                        style={{
                          ...styles.dropdownItem,
                          borderBottom: index !== clientList?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                        }}
                      >
                        {client?.client_name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <Dropdown
                ref={(el) => (dropdownRefs.current["Services"] = el)}
                isOpen={openDropdown === "Services"}
                toggleDropdown={() => toggleDropdown("Services")}
                label="Services"
                options={serviceOptions || []}
                value={filterData?.services}
                onChange={(value) => handleFilterChange('services', value)}
                loading={servicesLoading}
                errorMessage={servicesError}
              />
              <div  > {/* Add margin-bottom here */}
                <label> Generated Date</label>
                <DateInput
                  label="Generated Date"
                  value={filterData?.generatedDate || ""}
                  onChange={(e) => handleFilterChange("generatedDate", e.target.value)}
                />
              </div>
              <Dropdown
                ref={(el) => (dropdownRefs.current["Generated By"] = el)}
                isOpen={openDropdown === "Generated By"}
                toggleDropdown={() => toggleDropdown("Generated By")}
                label="Generated By"
                options={userOptions || []}
                placeholder="------"
                value={filterData?.generatedBy}
                onChange={(value) => handleFilterChange('generatedBy', value)}
                loading={userLoading}
                errorMessage={userError}
              />
            </div>
            <div>
              {filterError && <div className="list-error-msg" style={{ textAlign: 'left', paddingBottom: 5 }}> {filterError}</div>}
              <div className="tasksScreen-filter-buttons">
                <button onClick={applyFilters} className="tasksScreen-apply-button"
                  style={{ cursor: filterListLoading ? 'not-allowed' : 'pointer', opacity: filterListLoading ? 0.5 : 1 }} disabled={filterListLoading}>Apply</button>
                <button onClick={cancelFilters} className="tasksScreen-cancel-button"> Cancel</button>
                <button onClick={resetFilters} className="tasksScreen-reset-button"> Reset</button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className='basic-info-card' style={{ border: 'none', padding: '0px' }}>
        <div style={styles.tableWrapper}>
          <table className="tasksScreen-task-table">
            <thead>
              <tr>
                <th style={{ width: "10%" }}>Receipt No.</th>
                <th style={{ width: "15%" }}>Client Name</th>
                <th style={{ width: "20%" }}>Services/Category</th>
                <th style={{ width: "10%" }}>Generated Date</th>
                <th style={{ width: "20%" }}>Group Name</th>
                <th style={{ width: "10%" }}>Generated By</th>
                <th style={{ width: "10%" }}>Amount</th>
                <th style={{ width: "5%" }}></th>
              </tr>
            </thead>
            <tbody style={{ backgroundColor: "white" }}>
              {currentTasks?.map((receipt, index) => (
                <tr key={index}>
                  <td style={styles.tableLink} onClick={() => handleEdit(receipt)}>{receipt?.receipt_no}</td>
                  <td style={styles.tableValue}>{receipt?.client_name || '--'}</td>
                  <td style={styles.tableValue}>{receipt?.service_category_names || '--'}</td>
                  <td style={styles.tableValue}>{receipt?.receipt_date ? convertGMTToLocal(receipt?.receipt_date,'dd/MM/yyyy') : '--'}</td>
                  <td style={styles.tableValue}>{receipt?.group_name || '--'}</td>
                  <td style={styles.tableValue}>{receipt?.receipt_gen_emp_name || '--'}</td>
                  <td style={styles.tableValue}>{receipt?.receipt_type === 1 ? receipt?.received_amount : receipt?.advance_paid_amount}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "2px", // Space between edit and delete buttons
                      }}
                    >
                      {/* Print Button */}
                      {printReceiptLoading[receipt?.receipt_id] ? (
                        <span style={{ marginLeft: '5px' }}>
                          <Loader loading={printReceiptLoading[receipt?.receipt_id]} color={'var(--primary-loader-color)'} size="small" />
                        </span>
                      ) :
                        <button
                          className="tasksScreen-edit-button"
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: printReceiptLoading[receipt?.receipt_id] ? "not-allowed" : "pointer",
                            opacity: printReceiptLoading[receipt?.receipt_id] ? 0.5 : 1,
                          }}
                          disabled={printReceiptLoading[receipt?.receipt_id]}
                        >
                          <img
                            src={printIcon}
                            alt="Download"
                            style={{ width: "16px", height: "16px" }}
                            onClick={() => printReceiptDocument(receipt?.receipt_id)}
                          />
                        </button>
                      }
                      {/* Edit Button */}
                      {userPermissions?.invoices?.per_name_sub_json?.receipt_edit === 1 &&
                      <button
                        className="tasksScreen-edit-button"
                        style={{
                          border: "none",
                          background: "transparent",
                          cursor: printReceiptLoading[receipt?.receipt_id] ? "not-allowed" : "pointer",
                          opacity: printReceiptLoading[receipt?.receipt_id] ? 0.5 : 1,
                        }}
                        disabled={printReceiptLoading[receipt?.receipt_id]}
                      >
                        <img
                          src={editIcon}
                          alt="Edit"
                          style={{ width: "16px", height: "16px" }}
                          onClick={() => handleEdit(receipt)}
                        />
                      </button>
                      }

                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
          {loading && <Loader loading={loading} color={'var(--primary-loader-color)'} />}
          {error && <div className="list-error-msg">{error} </div>}
          {filterListLoading && <Loader loading={filterListLoading} color={'var(--primary-loader-color)'} />}
          {filterListError && <div className="list-error-msg">{filterListError} </div>}
          {/* <AddUserModal isOpen={isModalOpen} onClose={handleCloseModal}/> */}
        </div>

      </div>
      <hr className="divider" style={{ marginTop: '20px' }} />
      <div className="tasksScreen-table-footer" >
        <span className="tasksScreen-pagination-info">
          {`${currentPage}-${totalPages} of items`}
        </span>
        <div className="tasksScreen-pagination">
          <button
            className="tasksScreen-pagination-button"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1 || totalPages === 0}
          >
            <img src={leftArrowIcon} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image" />
          </button>
          {visiblePages.map((page) => (
            <button
              key={page}
              className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          ))}
          <button
            className="tasksScreen-pagination-button"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            <img src={leftArrowIcon} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image" />
          </button>
        </div>
      </div>
      {isModalOpen && (
        <GenerateReceiptModal isOpen={isModalOpen} onClose={handleCloseModal} />
      )}
    </>

  )

};

const styles = {
  categoryHeader: {
    color: '#1F384C',
    fontSize: 18,
    fontFamily: 'Roboto Slab',
    fontWeight: 500,
    paddingBottom: 20
  },
  tableWrapper: {
    overflowX: "auto", // Horizontal scroll
    whiteSpace: "nowrap", // Prevent table from wrapping on small devices
    // marginBottom:50
  },
  tableValue: {
    colour: '#192A3E',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px'
  },
  tableLink: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px',
    textDecoration: 'underline',
    color: '#5A55D2'
  },
  container: {
    padding: "5px",
    backgroundColor: "#EFF0F4",
    border: "none",
    // borderRadius: "5px",
    border: '1px #EFF0F4 solid'
  },
  filtersHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom: "15px",
  },
  filterButton: {
    backgroundColor: "white",
    color: "var(--button-bg-color)",
    border: "none",
    borderRadius: "5px",
    padding: "5px 8px",
    cursor: "pointer",
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    border: '1px var(--button-bg-color) solid'

  },
  filterIcon: {
    width: '10px',
    height: '10px',
    paddingRight: '5px'
  },

  paginationButtons: {
    display: "flex",
    gap: "5px",
  },
  paginationButton: {
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "5px 10px",
    cursor: "pointer",
  },
  filtersContainer: {
    // display: "flex",
    flexWrap: "wrap", // Wrap inputs to the next line if needed
    gap: "20px", // Space between inputs
    marginBottom: "15px",
    // justifyContent: "space-between", // Distribute inputs evenly
    border: '1px #EFF0F4 solid',
    padding: '10px'
  },
  buttonsContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  applyButton: {
    backgroundColor: "var(--button-bg-color)",
    color: "var(--button-text-color)",
    border: "none",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  cancelButton: {
    backgroundColor: "transparent",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  resetButton: {
    backgroundColor: "transparent",
    color: "#555",
    border: "none",
    cursor: "pointer",
  },
  labaleStyle: {
    fontSize: '12px',
    // marginBottom: '5px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    color: 'rgb(52, 60, 68)'
  },
  dropdownList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '4px',
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 1000,
    padding: 0, // Remove default padding
    margin: 0, // Remove default margin
    listStyleType: 'none', // Remove the dots
  },
  dropdownItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee', // Default for all items
    backgroundColor: '#fff',
    hover: {
      backgroundColor: '#f0f0f0',
    },
  },

}

export default InvoiceReceiptScreen;